import { TextField } from '@quintype/em/components/text-field';
import { TextArea } from '@quintype/em/components/text-area';
import get from 'lodash/get';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateBackupConfig, updateHaveUnsavedChanges } from '../../../actions/builder-action';
import { updateGlobalAiElementSettings } from '../../../actions/story-action';
import ActionButtons from '../../../molecules/action-buttons';
import PBInspector from '../../../molecules/inspector';
import { ThemeSetter } from '../../../molecules/theme-setter';
import { ToggleButton } from '../../../molecules/toggle-button';
import { IConfig, Window } from '../../../utils/interfaces';
import { Quiz } from './quiz';
import styles from './global-ai-elements-page.module.css';

interface IPBState {
  builder: {
    config: IConfig;
    haveUnsavedChanges: boolean;
  };
}

declare var window: Window;

const AI_ICONS = [
  {
    name: 'star',
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M5.825 21L7.45 13.975L2 9.25L9.2 8.625L12 2L14.8 8.625L22 9.25L16.55 13.975L18.175 21L12 17.275L5.825 21ZM17.25 7L17.775 4.775L16 3.3L18.35 3.1L19.25 1L20.15 3.1L22.5 3.3L20.725 4.775L21.25 7L19.25 5.825L17.25 7Z"
          fill="black"
        />
      </svg>
    )
  },
  {
    name: 'sparkle',
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_6169_488)">
          <path
            d="M12 0C11.4591 4.41494 11.2803 7.21839 10.2234 9.02811C8.4958 11.2775 5.50126 11.4917 0 12C5.41209 12.6548 8.33831 12.7968 10.071 14.8574C11.3655 16.6815 11.5845 19.5033 12 24C12.7057 18.168 12.8162 15.2229 15.3734 13.547C17.1915 12.6688 19.9046 12.4771 24 12C18.9219 11.3779 15.9755 11.2347 14.2214 9.68344C12.7382 7.91523 12.58 4.97914 12 0Z"
            fill="black"
          />
          <path d="M18 8L18.94 5.94L21 5L18.94 4.06L18 2L17.06 4.06L15 5L17.06 5.94L18 8Z" fill="black" />
        </g>
        <defs>
          <clipPath id="clip0_6169_488">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    name: 'wand',
    svg: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m14.06 9.02.92.92L5.92 19H5v-.92zM17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94zM11 5l.627-1.373L13 3l-1.373-.627L11 1l-.627 1.373L9 3l1.373.627zm-5 5 .94-2.06L9 7l-2.06-.94L6 4l-.94 2.06L3 7l2.06.94zm12 5-.94 2.06L15 18l2.06.94L18 21l.94-2.06L21 18l-2.06-.94z"
          fill="black"
        />
      </svg>
    )
  },
  {
    name: 'diamond',
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M9.93743 15.5C9.84815 15.1539 9.66777 14.8381 9.41505 14.5854C9.16232 14.3327 8.8465 14.1523 8.50043 14.063L2.36543 12.481C2.26076 12.4513 2.16864 12.3883 2.10304 12.3014C2.03744 12.2146 2.00195 12.1088 2.00195 12C2.00195 11.8912 2.03744 11.7854 2.10304 11.6986C2.16864 11.6118 2.26076 11.5487 2.36543 11.519L8.50043 9.93601C8.84638 9.84681 9.16212 9.66658 9.41483 9.41404C9.66754 9.16151 9.84799 8.84589 9.93743 8.50001L11.5194 2.36501C11.5488 2.25992 11.6118 2.16735 11.6987 2.1014C11.7857 2.03545 11.8918 1.99976 12.0009 1.99976C12.11 1.99976 12.2162 2.03545 12.3031 2.1014C12.39 2.16735 12.453 2.25992 12.4824 2.36501L14.0634 8.50001C14.1527 8.84608 14.3331 9.1619 14.5858 9.41462C14.8385 9.66734 15.1544 9.84773 15.5004 9.93701L21.6354 11.518C21.7409 11.5471 21.834 11.61 21.9003 11.6971C21.9666 11.7841 22.0025 11.8906 22.0025 12C22.0025 12.1094 21.9666 12.2159 21.9003 12.3029C21.834 12.39 21.7409 12.4529 21.6354 12.482L15.5004 14.063C15.1544 14.1523 14.8385 14.3327 14.5858 14.5854C14.3331 14.8381 14.1527 15.1539 14.0634 15.5L12.4814 21.635C12.452 21.7401 12.389 21.8327 12.3021 21.8986C12.2152 21.9646 12.109 22.0003 11.9999 22.0003C11.8908 22.0003 11.7847 21.9646 11.6977 21.8986C11.6108 21.8327 11.5478 21.7401 11.5184 21.635L9.93743 15.5Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M20 3V7" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22 5H18" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 17V19" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 18H3" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
];

const DUMMY_ELEMENT = {
  text: `<p>The state government on Monday announced a new policy aimed at improving public infrastructure and boosting local employment. Officials said the initiative will be rolled out in phases over the next six months, with priority given to rural and semi-urban districts.</p>
  <ul>
  <li>
  Article covers recent developments in AI and machine learning.
  </li>
  <li>New research shows significant improvements in natural language processing.</li>
  <li>Industry adoption continues to accelerate across multiple sectors.</li>
  </ul>`
};

const DUMMY_STORY = { 'published-at': Date.now() };

export const GlobalAiElementsPage = () => {
  const [showInspector, setShowInspector] = useState(false);
  const dispatch = useDispatch();
  const { config, haveUnsavedChanges } = useSelector((state: IPBState) => get(state, ['builder']));
  const enableDarkModePreview = get(config, ['enableDarkModePreview'], false);

  const aiSummaryConfig = get(config, ['story', 'globalAiElements', 'aiSummary'], {});
  const opts = get(aiSummaryConfig, ['opts'], {});
  const css = get(aiSummaryConfig, ['css'], {});

  const selectedIcon = get(opts, ['iconType'], 'star');
  const isEnabled = get(opts, ['enabled'], false);

  const updateOpts = (key: string, value: any) => {
    dispatch(updateGlobalAiElementSettings({ type: 'aiSummary', settingsType: 'opts', data: { [key]: value } }));
    dispatch(updateHaveUnsavedChanges(true));
  };

  const updateCss = (key: string, value: string) => {
    dispatch(updateGlobalAiElementSettings({ type: 'aiSummary', settingsType: 'css', data: { [key]: value } }));
    dispatch(updateHaveUnsavedChanges(true));
  };

  const openInspector = () => {
    dispatch(updateBackupConfig({ config }));
    setShowInspector(true);
  };

  const AISummaryComponent = window?.QT_STORY_COMPONENTS?.AISummary;

  return (
    <div className={styles.wrapper}>
      <div className={styles.sectionHeading}>Summary</div>

      <div className={styles.elementDetails}>
        <div className={styles.templateWrapper}>
          <div className={styles.hoverHeading}>AI Summary</div>
          <div className={styles.template}>
            {AISummaryComponent ? (
              <AISummaryComponent
                element={DUMMY_ELEMENT}
                story={DUMMY_STORY}
                opts={{
                  headline: get(opts, ['headline'], 'Quick Read'),
                  subtitle: get(opts, ['subtitle'], 'AI generated summary, newsroom reviewed'),
                  iconType: get(opts, ['iconType'], 'star'),
                  enabled: get(opts, ['enabled'], false),
                  expandOnStart: true
                }}
                css={css}
              />
            ) : null}
          </div>
          <div className={styles.buttonGroup}>
            <ActionButtons actionList={[{ action: 'setting', handler: openInspector }]} />
          </div>
        </div>
      </div>
      <Quiz />

      {showInspector && (
        <PBInspector
          title="AI Summary Element"
          isActive={showInspector}
          isActionButtonDisabled={!haveUnsavedChanges}
          onActionButtonClick={() => setShowInspector(false)}
          onClose={() => setShowInspector(false)}
        >
          <ToggleButton
            label="Enable AI Summary"
            toggleName="enabled"
            id="ai-summary-enabled"
            updateToggleState={get(opts, ['enabled'], false)}
            updateToggleButton={(name, checked) => updateOpts(name, checked)}
          />
          <p className={styles.toggleDescription}>
            When turned ON, AI summaries will use the dedicated AI Summary design. When turned OFF, they will follow the
            default design set in Global Story Elements.
          </p>
          {isEnabled && (
            <>
              <TextField
                label="Title"
                placeholder="Quick Read"
                value={get(opts, ['headline'], 'Quick Read')}
                onChange={(value: string) => updateOpts('headline', value)}
              />
              <TextArea
                label="Subtitle"
                placeholder="AI generated summary, newsroom reviewed"
                value={get(opts, ['subtitle'], 'AI generated summary, newsroom reviewed.')}
                onChange={(value: string) => updateOpts('subtitle', value)}
              />
              <ThemeSetter
                label="Border Color"
                updateTheStore={(key: string, value: string) => updateCss(key, value)}
                lightColorExtract={get(css, ['borderColor'], '')}
                lightUpdateStoreKey="borderColor"
                lightDefaultColor="#4860BC"
                darkColorExtract={get(css, ['darkBorderColor'], '')}
                darkUpdateStoreKey="darkBorderColor"
                darkDefaultColor="#4860BC"
                enableDarkModePreview={enableDarkModePreview}
              />
              <ThemeSetter
                label="Background Color"
                updateTheStore={(key: string, value: string) => updateCss(key, value)}
                lightColorExtract={get(css, ['backgroundColor'], '')}
                lightUpdateStoreKey="backgroundColor"
                lightDefaultColor="#ffffff"
                darkColorExtract={get(css, ['darkBackgroundColor'], '')}
                darkUpdateStoreKey="darkBackgroundColor"
                darkDefaultColor="#1a1a1a"
                enableDarkModePreview={enableDarkModePreview}
              />
              <div className={styles.iconSelectLabel}>Select AI Icon</div>
              <div className={styles.iconSelectWrapper}>
                {AI_ICONS.map(icon => (
                  <div
                    key={icon.name}
                    className={selectedIcon === icon.name ? styles.iconOptionSelected : styles.iconOption}
                    onClick={() => updateOpts('iconType', icon.name)}
                  >
                    {icon.svg}
                  </div>
                ))}
              </div>
              <ThemeSetter
                label="Icon Color"
                updateTheStore={(key: string, value: string) => updateCss(key, value)}
                lightColorExtract={get(css, ['iconColor'], '')}
                lightUpdateStoreKey="iconColor"
                lightDefaultColor="#4860BC"
                darkColorExtract={get(css, ['darkIconColor'], '')}
                darkUpdateStoreKey="darkIconColor"
                darkDefaultColor="#4860BC"
                enableDarkModePreview={enableDarkModePreview}
              />
            </>
          )}
        </PBInspector>
      )}
    </div>
  );
};
